import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { LoadingShimmerModule } from 'loading-shimmer';

@Component({
  selector: 'app-member-verification-label-item',
  templateUrl: './member-verification-label-item.component.html',
  styleUrls: ['./member-verification-label-item.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, LoadingShimmerModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberVerificationLabelItemComponent {
  @Input() label: string | undefined;
  @Input() text: string | number | undefined;
  @Input() highlightRow: boolean = true;
  @Input() hideBottomBorder: boolean = false;
  @Input() isLoading: boolean = false;
}
